<template>
    <div class="form-group col-sm-12 col-lg-12">
        <label for="keywords">Keywords:</label>
        <div>
            <div class="chip-container" >
                <div class="chip" v-for="(chip, i) of chipsStages" :key="chip.label">
                    {{ chip }}
                    <i class="material-icons" @click="deleteChipStage(i)">clear</i>
                </div>
                <input id="keywords_input" name="keywords_input" ref="keywrdStage" v-model="currentInputStage" @keyup="evalKeyStage" @keydown.delete="backspaceDeleteStage" />
            </div>
            <div class="help-block">Ingrese keywords separados por comas (,) .</div>
            <div class="help-block" v-for="e in errors['keywordsStage']">{{ e }}</div>
        </div>
        <input id="keywords" name="keywords" type="hidden" :value="keywordsStage" />
    </div>
</template>
<style type="text/css">
.chip-container {
    border: 1px solid #ccc;
    border-radius: 4px;
    min-height: 70px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    .chip {
        margin: 4px;
        background: #e0e0e0;
        padding: 0px 4px;
        border: 1px solid #ccc;
        border-radius: 3px;
        display: flex;
        align-items: center;
        i {
            cursor: pointer;
            opacity: 0.56;
            margin-left: 8px;
        }
    }
    input {
        flex: 1 1 auto;
        width: 30px;
        border: none;
        outline: none;
        padding: 6px 12px;
    }
}
</style>
<script>
    // {{ component.input_title_1 }}
    export default {
        props: [
            "hitovida"
        ],
        data: function() {
            const hitovida = _.cloneDeep(this.hitovida);

            return {
                data: hitovida,
                currentInputStage: '',
                keywordsStage: '',
                chipsStages: [],
                set: {
                    type: Boolean,
                    default: true
                },
                errors: {}
            };
        },
        mounted: function() {

            var keywords = [];
            if (this.data.keywords){
                keywords = this.data.keywords.split(",");
            }
            var filtered = keywords.filter(function(e) {
                return e;
            });
            filtered = filtered.map(function(s) {
                return String.prototype.trim.apply(s);
            });
            this.chipsStages = filtered;
            this.keywordsStage = this.chipsStages.join(", ");
        },
        created:function() {

        },
        methods: {
            deleteChipStage(index) {
                this.chipsStages.splice(index, 1);
                this.updateDataStage();
            },
            updateDataStage() {
                this.keywordsStage = this.chipsStages.join(", ");
            },
            evalKeyStage: function(event) {
                if (event.key === ",") {
                    this.currentInputStage = this.currentInputStage.split(",").join("");

                    if (this.currentInputStage.length) {
                        this.saveChipStage();
                        this.addkeywordStage = true;
                    }
                }
            },
            saveChipStage() {
                const { chipsStages, currentInputStage, set } = this;

                ((set && chipsStages.indexOf(currentInputStage) === -1) || !set) && chipsStages.push(currentInputStage);
                this.currentInputStage = "";
                this.updateDataStage();
            },
            backspaceDeleteStage({ which }) {
                which == 8 &&
                this.currentInputStage === "" &&
                this.chipsStages.splice(this.chipsStages.length - 1);
                this.updateDataStage();
            },

        }
    }
</script>
